import styled from "styled-components";

const ButtonVal = styled.button`
    background-color: #87e20f;
    color: #fff;
    display: block;
    width: 100%;
    border: none;
    cursor: pointer;
    padding: 20px 30px;
    border-radius: 20px;
    margin-bottom: 20px;
    text-transform: uppercase;
    font-size: 20px;
    margin-bottom: 20px;

    &.login {
        margin-bottom: 0;
        margin-top: 20px;
    }
`

function Button({type, text, className, onClick}) {
    return(
        <ButtonVal type={type} className={className} onClick={onClick}>{text}</ButtonVal>
    )
}

export default Button;